Array.prototype.groupBy = function(grouper) {
  return this.reduce((all, item) => {
    const key = grouper(item);

    if (all[key] === undefined) { all[key] = []; }
    all[key].push(item);

    return all;
  }, {});
};
